import {
  Box,
  ClickAwayListener,
  PopperProps,
  Popper,
  Popover
} from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, useRef } from 'react';
import { useStyles } from './style';
import SLabel from '../../../../sui/slabel';

interface SSelectDropdownProps
  extends Omit<PopperProps, 'children' | 'open' | 'content'> {
  width?: number;
  anchor: JSX.Element;
  anchorElement?: HTMLElement | null;
  content: JSX.Element;
  placement?: PopperProps['placement'];
  // Refactor to use dropdownOpen instead of anchorElement
  dropdownOpen?: boolean;
  onClose: (e: React.MouseEvent<Document>) => void;
  marginTop?: number;
  className?: string;
  fullWidth?: boolean;
  label?: string;
  // ! This sloud be removed when we migrate whole app new design
  newDesign?: boolean;
  required?: boolean;
  dropdownContainerStyle?: CSSProperties;
  withPopover?: boolean;
}

const SSelectDropdown = ({
  fullWidth = false,
  width,
  anchor,
  anchorElement,
  content,
  placement = 'bottom-end',
  onClose,
  dropdownOpen,
  className = '',
  marginTop = 4,
  label = '',
  newDesign = false,
  dropdownContainerStyle,
  required,
  withPopover = false,
  ...rest
}: SSelectDropdownProps) => {
  const classes = useStyles({ width });
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div
        ref={anchorRef}
        style={{
          ...(fullWidth ? { width: '100%' } : {})
        }}>
        {!!label && (
          <SLabel
            title={label}
            variant="body2"
            style={{
              marginBottom: 8,
              display: 'block'
            }}
            required={required}
          />
        )}

        {anchor}
      </div>
      {withPopover ? (
        <Popover
          style={{
            marginTop,
            ...dropdownContainerStyle
          }}
          PaperProps={{
            style: {
              maxWidth: 'unset !important'
            }
          }}
          className={newDesign ? classes.withPopper : classes.popper}
          open={anchorElement ? Boolean(anchorElement) : dropdownOpen}
          // @ts-ignore
          anchorEl={anchorElement || anchorRef.current}
          placement={placement}
          {...rest}>
          <ClickAwayListener onClickAway={onClose}>
            <Box className={clsx(classes.content, className)}>{content}</Box>
          </ClickAwayListener>
        </Popover>
      ) : (
        <Popper
          style={{ marginTop, ...dropdownContainerStyle }}
          className={newDesign ? classes.popperV2 : classes.popper}
          open={anchorElement ? Boolean(anchorElement) : dropdownOpen}
          anchorEl={anchorElement || anchorRef.current}
          placement={placement}
          {...rest}>
          <ClickAwayListener onClickAway={onClose}>
            <Box className={clsx(classes.content, className)}>{content}</Box>
          </ClickAwayListener>
        </Popper>
      )}
    </>
  );
};

export default SSelectDropdown;
